export const MIN_LAT = -85.05112878;
export const MAX_LAT = 85.05112878;
export const MIN_LON = -180;
export const MAX_LON = 180;

export const decodeGeoHash = (hash: number, bitDepth?: number) => {
  const bbox = decodeBBoxInt(hash, bitDepth);
  return convertBBoxToLatLong(bbox);
};

export const getBit = (bits: number, position: number): number => {
  return (bits / Math.pow(2, position)) & 0x01;
};

export const convertBBoxToLatLong = (bbox) => {
    const lat = (bbox[0] + bbox[2]) / 2;
    const lon = (bbox[1] + bbox[3]) / 2;
    const latErr = bbox[2] - lat;
    const lonErr = bbox[3] - lon;
    return {
      latitude: lat,
      longitude: lon,
      error: { latitude: latErr, longitude: lonErr },
    };
}

export const decodeBBoxInt = (hashInt: number, bitDepth = 52) => {
    let maxLat = MAX_LAT,
    minLat = MIN_LAT,
    maxLon = MAX_LON,
    minLon = MIN_LON;

  let latBit = 0,
    lonBit = 0;
  const step = bitDepth / 2;

  for (let i = 0; i < step; i++) {
    lonBit = getBit(hashInt, (step - i) * 2 - 1);
    latBit = getBit(hashInt, (step - i) * 2 - 2);

    if (latBit === 0) {
      maxLat = (maxLat + minLat) / 2;
    } else {
      minLat = (maxLat + minLat) / 2;
    }

    if (lonBit === 0) {
      maxLon = (maxLon + minLon) / 2;
    } else {
      minLon = (maxLon + minLon) / 2;
    }
  }
  return [minLat, minLon, maxLat, maxLon];
}
